import { MapPin, Mail, MessageCircle } from "lucide-react";
import { useT } from "@/lib/i18n";
import siteConfig from "@/config/site.json";

export function OfficeMap() {
  const { tk } = useT();
  const email = siteConfig.contact.emails[0]?.address ?? "info@bosquesuspendido.com";

  return (
    <section className="border-t border-gold/15">
      <div className="max-w-5xl mx-auto px-6 py-20 text-center">
        <span className="text-xs tracking-[0.4em] uppercase text-gold">
          {tk("contact.visit.kicker", "Cómo llegar")}
        </span>
        <h2 className="font-serif text-3xl md:text-4xl mt-4">
          {tk("contact.visit.title.a", "Te esperamos en el ")}
          <em className="not-italic gold-gradient">
            {tk("contact.visit.title.b", "pinar de La Juliana")}
          </em>
        </h2>
        <p className="mt-5 text-muted-foreground max-w-2xl mx-auto leading-relaxed">
          {tk(
            "contact.visit.intro",
            "El Bosque Suspendido se encuentra en el Centro de Naturaleza La Juliana, en Bollullos de la Mitación, a solo 15 minutos de Sevilla. Aparcamiento gratuito para coches y autobuses."
          )}
        </p>

        <div className="mt-10 grid sm:grid-cols-3 gap-5 max-w-3xl mx-auto">
          <a
            href="https://www.google.com/maps/search/?api=1&query=Centro+de+Naturaleza+La+Juliana+Bollullos+de+la+Mitaci%C3%B3n"
            target="_blank"
            rel="noopener noreferrer"
            className="rounded-2xl border border-gold/20 bg-card/30 p-6 hover:border-gold/60 transition-colors"
          >
            <MapPin size={20} className="text-gold mx-auto" />
            <div className="mt-3 text-[10px] tracking-[0.3em] uppercase text-gold/80">
              {tk("contact.visit.address.label", "Dirección")}
            </div>
            <div className="mt-1 text-sm text-foreground/85">
              {tk("contact.visit.address.line", "Ctra. A-474 Bollullos de la Mitación — Aznalcázar, Km 15,5")}
            </div>
          </a>
          <a
            href={`mailto:${email}`}
            className="rounded-2xl border border-gold/20 bg-card/30 p-6 hover:border-gold/60 transition-colors"
          >
            <Mail size={20} className="text-gold mx-auto" />
            <div className="mt-3 text-[10px] tracking-[0.3em] uppercase text-gold/80">
              Email
            </div>
            <div className="mt-1 text-sm text-foreground/85 break-all">{email}</div>
          </a>
          <a
            href={`https://wa.me/${siteConfig.contact.whatsapp.number.replace(/\D/g, "")}`}
            target="_blank"
            rel="noopener noreferrer"
            className="rounded-2xl border border-gold/20 bg-card/30 p-6 hover:border-gold/60 transition-colors"
          >
            <MessageCircle size={20} className="text-gold mx-auto" />
            <div className="mt-3 text-[10px] tracking-[0.3em] uppercase text-gold/80">
              WhatsApp
            </div>
            <div className="mt-1 text-sm text-foreground/85">
              {siteConfig.contact.whatsapp.number}
            </div>
          </a>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 pb-20">
        <div className="rounded-3xl overflow-hidden border-4 border-card shadow-2xl">
          <iframe
            src="https://www.google.com/maps?q=Centro+de+Naturaleza+La+Juliana,+Bollullos+de+la+Mitaci%C3%B3n,+Sevilla&z=13&output=embed"
            title="Mapa de cómo llegar al Bosque Suspendido — Centro de Naturaleza La Juliana"
            className="w-full h-[28rem] md:h-[32rem] block"
            style={{ border: 0 }}
            loading="lazy"
            allowFullScreen
            referrerPolicy="no-referrer-when-downgrade"
          />
        </div>
      </div>
    </section>
  );
}
